import(/* webpackMode: "eager" */ "/codebuild/output/src3707151643/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
